<div>
    <app-system-response
        responseType="error"
        size="small"
        [title]="title"
        [message]="bodyText"
        [basicPrimaryButtonText]="cancelButtonText"
        (basicPrimaryButtonClick)="onCancelClick()"
        [flatPrimaryButtonText]="actionButtonText"
        (flatPrimaryButtonClick)="onActionButtonClick()"
    ></app-system-response>
</div>
